// Libs
import { subWeeks } from 'date-fns';
// App
import { formatDate } from 'app-shared/lib/utils/date.utils';
import { OrderStatisticsFilters } from 'app-shared/lib/api/shop-administration/order/statistics';
import { StatisticsPeriod } from 'app-shared/lib/api/shared';
import { TimeFilters } from '../shared/time-filters';
import { TIME_PERIOD, TIME_PERIODS_CONFIG } from '../shared/time-filters/filters.constants';
import { buildCustomPeriodQueryParams, buildPreviousCustomPeriodQueryParams } from './custom-period.utils';
import { LAST_PERIOD_LABELS } from './summary/main-summary.constants';

export const buildInitialFilters = (): TimeFilters => {
  const initialFilters: TimeFilters = {
    selectedTimePeriod: TIME_PERIOD.DAY,
    selectedFilterDate: new Date(),
    navigationDate: new Date(),
  };

  return initialFilters;
};

const buildSelectedPeriodQueryParams = (filters: TimeFilters, isSmallScreen: boolean): OrderStatisticsFilters => {
  const config = TIME_PERIODS_CONFIG(isSmallScreen)[filters.selectedTimePeriod];
  const { startOfPeriodHandler, endOfPeriodHandler } = config;

  const queryParams: OrderStatisticsFilters = {
    startDate: startOfPeriodHandler(filters.selectedFilterDate),
    endDate: endOfPeriodHandler(filters.selectedFilterDate),
  };

  return queryParams;
};

const subComparedPeriod = (date: Date, selectedTimePeriod: TIME_PERIOD, isSmallScreen: boolean): Date => {
  const { subPeriodsHandler } = TIME_PERIODS_CONFIG(isSmallScreen)[selectedTimePeriod];
  let comparedDate = subPeriodsHandler(date, 1);

  if (selectedTimePeriod == TIME_PERIOD.DAY) {
    comparedDate = subWeeks(date, 1);
  }

  return comparedDate;
};

const buildPreviousSelectedPeriodQueryParams = (
  filters: TimeFilters,
  isSmallScreen: boolean
): OrderStatisticsFilters => {
  const { selectedTimePeriod, selectedFilterDate } = filters;
  const { startOfPeriodHandler, endOfPeriodHandler } = TIME_PERIODS_CONFIG(isSmallScreen)[selectedTimePeriod];

  const queryParams: OrderStatisticsFilters = {
    startDate: subComparedPeriod(startOfPeriodHandler(selectedFilterDate), selectedTimePeriod, isSmallScreen),
    endDate: subComparedPeriod(endOfPeriodHandler(selectedFilterDate), selectedTimePeriod, isSmallScreen),
  };

  return queryParams;
};

export const buildCurrentPeriodQueryParams = (filters: TimeFilters, isSmallScreen: boolean): OrderStatisticsFilters => {
  const isCustomPeriodSelected = filters.selectedTimePeriod == TIME_PERIOD.CUSTOM;
  let queryParams: OrderStatisticsFilters;

  if (isCustomPeriodSelected) {
    queryParams = buildCustomPeriodQueryParams(filters.customPeriod);
  } else {
    queryParams = buildSelectedPeriodQueryParams(filters, isSmallScreen);
  }

  return queryParams;
};

export const buildLastPeriodQueryParams = (filters: TimeFilters, isSmallScreen: boolean): OrderStatisticsFilters => {
  const isCustomPeriodSelected = filters.selectedTimePeriod == TIME_PERIOD.CUSTOM;
  let queryParams: OrderStatisticsFilters;

  if (isCustomPeriodSelected) {
    queryParams = buildPreviousCustomPeriodQueryParams(filters.customPeriod);
  } else {
    queryParams = buildPreviousSelectedPeriodQueryParams(filters, isSmallScreen);
  }

  return queryParams;
};

export const buildStatisticsPeriod = (queryParams: OrderStatisticsFilters): StatisticsPeriod => {
  const { startDate, endDate } = queryParams;
  const period: StatisticsPeriod = { startDate, endDate };

  return period;
};

export const buildLastPeriodLabel = (filters: TimeFilters): string => {
  let label = LAST_PERIOD_LABELS[filters.selectedTimePeriod];

  if (filters.selectedTimePeriod == TIME_PERIOD.DAY) {
    label = `Le ${formatDate(filters.selectedFilterDate, 'EEEE')} précédent`;
  }

  return label;
};
